import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import request from '@/api/request'

export interface OperationPlatform { id: string; name: string; edition: string; kinds: string[]; executor: string; publishing: boolean; metrics: boolean }
export const useOperationsStore = defineStore('operations', () => {
  const edition = ref(''), platforms = ref<OperationPlatform[]>([])
  let pending: Promise<void> | undefined
  async function load() {
    if (edition.value) return
    if (!pending) pending = request.get('/operations/config').then((data: any) => {
      if (!['domestic','overseas','migration'].includes(data.edition) || !Array.isArray(data.platforms)) throw new Error('Invalid operations configuration')
      edition.value = data.edition; platforms.value = data.platforms
    }).finally(() => { pending = undefined })
    return pending
  }
  const supports = (id: string) => platforms.value.some(platform => platform.id === id)
  return { edition, platforms, load, supports, domestic: computed(() => edition.value === 'domestic') }
})
